import { TirPmNotificationEventBus, TirPmNotificationModel } from "tir-components";

/**Отправка уведомления об ошибке */
export const SendErrorNotification = (message: string) => {
  TirPmNotificationEventBus.emit(
    "add",
    new TirPmNotificationModel({
      title: message,
      type: "error",
      group: "general",
      life: 5000,
      closable: true,
      callbackButton: () => {},
    }),
  );
};
